import React, { FunctionComponent } from 'react';

export const PossiblyArchivedListName: FunctionComponent<{ name: string; isArchived: boolean }> = (props) =>
  props.isArchived ? <s>{props.name} (archived)</s> : <>{props.name}</>;
